import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../js/IncludeManager'
import { GoodsPhoto, GoodsCategory, GoodsFilter, NoResult, Alert } from '../../js/ComponentManager'
 
import { HeaderSub2 } from '../Common/HeaderSub2'
import { Link } from 'react-router-dom';

import { DataContext } from '../Layout';

/* 개발담당:양유빈
 * 화면기능:메인에서 더보기 클릭 후 리스트
 * 세부설명:
*/

export class SepecialEvent extends Component {
    static displayName = SepecialEvent.name;
    static contextType = DataContext;
    constructor(props) {
        super(props);
        this.state = {
            Sub_list_title: "",
            TotalCount: 0,
            CategoryMid: [],
            CategorySub: [],
            Mid_Cd: "",
            Sub_Cd: "",
            GoodsList: [],
            Category_use: "N",
            Filter_use: "N",
            Cntt_tye:"",
            SearchText: ""
        };

        this.Mgr_no = Big3Common.Util.GetParams("mgr_no");

        this.GoodsCategoryRef = React.createRef();
        this.GoodsFilterRef = React.createRef();
 
        this.CategoryCallback = this.CategoryCallback.bind(this);
        this.handelFilterInit = this.handelFilterInit.bind(this);
        this.FilterCallback = this.FilterCallback.bind(this);
        this.handleAddMore_Click = this.handleAddMore_Click.bind(this);

        this.handleSearch_Click = this.handleSearch_Click.bind(this);
        this.handleSearch_Change = this.handleSearch_Change.bind(this);
        this.handleSearchClear_Click = this.handleSearchClear_Click.bind(this);
        this.handle_onScroll = this.handle_onScroll.bind(this);
    }
    SearchModel = {
        Man_Cd: "",
        Mid_Cd: "",
        Sub_Cd: "",
        Display: "all",
        Order_By: "reg_dt",
        Start_Price: 0,
        End_Price: 1000000,
        Goods_Nm: "",
        Page_Number: 1,
        Page_Size: Big3Common.WebConfig.Page_Size,
        Mgr_no: this.Mgr_no,
        UI_Position: "SUB_LIST",
        fltr_tye: "BN"
    }
    //초기화
    async componentDidMount() {

        window.parent.CallBakBig3Common(Big3Common);
        window.addEventListener('scroll', this.handle_onScroll);

        this.SearchModel.Page_Number = 1;
        this.CallGoodsList("");
        //로그 기록
        Big3Common.RegisterTrackingLog({
            [Big3Common.ContentState.Page_cd]: "EP",
            [Big3Common.ContentState.Mgr_No]: this.Mgr_no,
            [Big3Common.ContentState.Basket_Yn]: "N"
        });
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handle_onScroll);
    }
    handle_onScroll() {
        if (Big3Common.WebConfig.ScrollEvent === false) {
            return false;
        }
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1) {
            Big3Common.WebConfig.ScrollEvent = false;
            this.handleAddMore_Click()
        }
    }
    //엔터 이벤트
    async handleSearch_Click(event) {

        if (event.keyCode === 13) {
            if (this.state.SearchText.trim() === "") {
                this.setState({ Title: "상품명을 입력하여 주세요." });
                Big3Common.ModalAlert(bootstrap, "MessageAlert");
                return false;
            }
            const SearchText = event.target.value;
            this.CallGoodsList(SearchText);
        }
        event.preventDefault();
    }
    //키워드 변경 이벤트
    async handleSearch_Change(event) {
        let Value = event.target.value;
        this.setState({ SearchText: Value });
        event.preventDefault();
    }
    //검색 초기화
    handleSearchClear_Click = async (event) => {
        this.setState({ SearchText: "" });
        this.SearchModel.Page_Number = 1;
        this.CallGoodsList("");
        event.preventDefault();
    }
    //데이터 조회
    async CallGoodsList(SearchText, isAppend = false) {
        try {
            Big3Common.Util.LoadingOn();
            console.log(this.Mgr_no)
            this.SearchModel.Goods_Nm = SearchText;
            this.SearchModel.Mgr_no = this.Mgr_no;
            let Data = await Big3Common.Post('api/AdMgr/HomeAd/GetMainSettingList',
                this.SearchModel, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.multiDataTable);
                let goodslist = DataList.goodsList;
                const TotalCount = (this.SearchModel.Page_Number * this.SearchModel.Page_Size);
                if (isAppend) {
                    //페이징 처리
                    let GoodListPush = this.state.GoodsList;
                    goodslist.map(list => GoodListPush.push(list));
                    this.setState({
                        GoodsList: GoodListPush,
                        TotalCount: TotalCount
                    });
                }
                else {
                    let Category_use = DataList.category_use;
                    let Filter_use = DataList.Filter_use;
                    const Cntt_tye = DataList.cntt_tye;
                    if (Cntt_tye === "WH") {
                        Category_use = "N";
                        Filter_use = "N";
                    }
                    this.setState({
                        GoodsList: goodslist,
                        TotalCount: TotalCount,
                        Sub_list_title: DataList.sub_list_title,
                        Category_use: Category_use,
                        Filter_use: Filter_use,
                        Cntt_tye: Cntt_tye
                    });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallGoodsList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //카테고리 클릭
    CategoryCallback(CategoryCd) {
        this.SearchModel.Man_Cd = CategoryCd.Man_Cd;
        this.SearchModel.Mid_Cd = CategoryCd.Mid_Cd;
        this.SearchModel.Sub_Cd = CategoryCd.Sub_Cd;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;
        this.CallGoodsList(this.state.SearchText);
    }
    //필터조건 검색 Callback 함수
    FilterCallback(Filter) {

        this.SearchModel.Display = Filter.Display;
        this.SearchModel.Order_By = Filter.Order_By;
        this.SearchModel.Start_Price = Filter.Start_Price;
        this.SearchModel.End_Price = Filter.End_Price;
        //페이지 및 값 모델 초기화
        this.SearchModel.Page_Number = 1;
        this.CallGoodsList(this.state.SearchText);
    }
    //필터 초기화
    handelFilterInit() {

        this.GoodsCategoryRef.current.CategoryDataCall();
        this.GoodsFilterRef.current.handleClear_Click();

        this.SearchModel.Man_Cd = "";
        this.SearchModel.Mid_Cd = "";
        this.SearchModel.Sub_Cd = "";
        this.SearchModel.Display = "all";
        this.SearchModel.Order_By = "reg_dt";
        this.SearchModel.Start_Price = 0;
        this.SearchModel.End_Price = 1000000;
        //페이지 및 값 모델 초기화
        this.setState({ SearchText: "" });

        this.SearchModel.Page_Number = 1;
        this.CallGoodsList("");
    }
    //더보기 클릭
    handleAddMore_Click() {
        this.SearchModel.Page_Number++;
        this.CallGoodsList(this.state.SearchText, true);
        //로그 기록
        Big3Common.RegisterTrackingLog({
            [Big3Common.ContentState.Page_cd]: "EM",
            [Big3Common.ContentState.Mgr_No]: this.Mgr_no,
            [Big3Common.ContentState.Basket_Yn]: "N"
        });
        return false;
    }
    //상품상세보기 클릭
    async handleGoodsDtl_Click(e, goods_no, uid) {
       
        this.context.Layout_GoodsDtl(
            {
                goods_no: goods_no,
                uid: uid,
                isshow: true,
                headhide: true,
                scrollevent: false
            });

        Big3Common.RegisterTrackingLog({
            [Big3Common.ContentState.Page_cd]: "DP",
            [Big3Common.ContentState.Mgr_No]: this.Mgr_no,
            [Big3Common.ContentState.Uid]: uid,
            [Big3Common.ContentState.Goods_No]: goods_no,
            [Big3Common.ContentState.Basket_Yn]: "N"
        });
    }
    //상품 리스트
    GoodsListrender() {
        const GoodsList = this.state.GoodsList;
        return (
            GoodsList.map((list, idx) =>
                <div className="product" key={idx} onClick={(e) => { this.handleGoodsDtl_Click(e, list.goods_no, list.uid) }}>
                    <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                        Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                        BackGround={true}
                        SimilarityYn="Y"
                    />
                    <div className="shop_name">{list.whole_name}</div>
                    <div className="product_name">{list.goods_nm}</div>
                    <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                    {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                </div>
            )
        )
    }
    //상가리스트
    WholeListrender() {
        const GoodsList = this.state.GoodsList;
        return (
            GoodsList.map((list, idx) =>
                <div className="product" key={idx}>
                    <Link to={`/Search/Goods/Index?Uid=${list.uid}`}>
                        <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                            BackGround={true}
                        />
                    </Link>
                    <div className="shop_name">{list.whole_name}</div>
                    <div className="product_name">{`${list.bld_name} ${list.flr_name}층 ${list.whole_no_name}호`}</div>
                </div>
            )
        )
    }
    render() {
       
        return (
            <>
                <HeaderSub2
                    HeaderTitle={this.state.Sub_list_title}
                    HistoryBack={true}
                />
                <div id="parent_goods_list">

                    <div className="b_margin d_padding container_box">
                        <div className="search_box seach_box_v2">
                            <input type="search"
                                inputMode="search"
                                placeholder="검색어를 입력해주세요."
                                className="form-control"
                                onKeyUp={(e) => { this.handleSearch_Click(e) }}
                                onChange={this.handleSearch_Change}
                                value={this.state.SearchText}

                            />
                            <div className="search_icon"></div>
                            <div className="search_delete sd2" onClick={(e) => { this.handleSearchClear_Click(e) }}></div>

                        </div>
                        <div className="recent_product result_box">
                            <div className="select_box">
                                <div className={this.state.Category_use === "Y" ? "category_box" : "item_hide"}
                                    onClick={(event) => {
                                        Big3Common.ModalAlert(bootstrap, 'GoodsCategory');
                                        event.preventDefault();
                                    }}
                                >
                                    <div className="category">카테고리</div>
                                    <div className="category_btn"></div>
                                </div>
                                <div className={this.state.Filter_use === "Y" ? "category_box filter" : "item_hide"}
                                    onClick={(event) => {
                                        Big3Common.ModalAlert(bootstrap, 'GoodsFilter');
                                        event.preventDefault();
                                    }}
                                >
                                    <div className="category filter">필터</div>
                                    <div className="category_btn"></div>
                                </div>
                                <div className="category_box reset"
                                    onClick={this.handelFilterInit}>
                                    <div className="category">초기화</div>
                                    <div className="reset_btn"></div>
                                </div>
                            </div>
                            <div className="recent_poroducts row row-cols-3 result">
                                {this.state.Cntt_tye === "WH" ? this.WholeListrender() : this.GoodsListrender()}
                            </div>
                            {this.state.TotalCount === this.state.GoodsList.length ? <div className="more_btn_box2"><button className="more_btn2" onClick={this.handleAddMore_Click}>더 보기</button></div> : ""}
                        </div>
                    </div>
                </div>
                <NoResult
                    Visible={this.state.GoodsList.length === 0 ? true : false}
                    Top={"60%"}
                />
                <GoodsCategory
                    id="GoodsCategory"
                    CallBack={this.CategoryCallback}
                    ref={this.GoodsCategoryRef}
                />
                <GoodsFilter
                    id="GoodsFilter"
                    CallBack={this.FilterCallback}
                    ref={this.GoodsFilterRef}
                />
                <Alert
                    id="MessageAlert"
                    title={this.state.Title}
                />
            </>
        );
    }
}
